import { Component, OnInit, Input } from '@angular/core';

export enum CssStyle {
  TECHNICAL_ERROR = 'technicalError',
  DATA_INCIDENCE = 'dataIncidence',
  TECHNICAL_BILLING_ERROR = 'technicalBillingError',
}

@Component({
  selector: 'app-task-type',
  templateUrl: './task-type.component.html',
  styleUrls: ['./task-type.component.css']
})

export class TaskTypeComponent implements OnInit {

  @Input() type: string;
  style: CssStyle;

  constructor() { }

  ngOnInit() {
    this.style = this.getCssStyle();
  }

  public getCssStyle() {
    switch (this.type) {
      case 'technicalError':
        return CssStyle.TECHNICAL_ERROR;
      case 'technicalBillingError':
        return CssStyle.TECHNICAL_BILLING_ERROR;
      case 'dataIncidence':
        return CssStyle.DATA_INCIDENCE;
      default:
        return CssStyle.DATA_INCIDENCE;
    }
  }
}

